<template>
  <b-row class="match-height">
    <b-col cols="12">
      <b-row>
        <b-col class="col-12 col-md-3">
          <b-row>
            <b-col
              v-show="!details"
              class="col-12"
            >
              <card-analytic-total-page-views-daily
                title="Compared to 7 Days Ago"
                :data-object="pageViewsTotal"
                :on-progress="pageViewsTotalOnProgress"
                :user-statistics="userStatistics"
                :user-statistics-on-progress="userStatisticsOnProgress"
                :pv-seven-days-ago="graphMinutely7DayAgo"
                :pv-seven-days-ago-on-progress="graphMinutely7DayAgoOnProgress"
                :user-statistics-seven-days-ago="userStatisticsSevenDaysAgo"
                :user-statistics-seven-days-ago-on-progress="userStatisticsSevenDaysAgoOnProgress"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col
              class="col-12"
            >
              <page-filter :filters="getFilterObject()" />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-show="!details"
          class="col-12 col-md-9"
        >
          <b-row>
            <b-col cols="12">
              <apex-line-area-chart-daily
                v-if="!isMobile()"
                :series1-name="seriesName7DaysAgo"
                :series1="graphMinutely7DayAgo"
                :series2-name="seriesName1DayAgo"
                :series2="graphMinutelyYesterday"
                :series3-name="seriesNameCurrentDay"
                :series3="graphMinutelyToday"
                :avg-statistics="pageViewsTotal"
                :avg-statistics-on-progress="pageViewsTotalOnProgress"
                :re-render="apexRender"
                :on-progress="graphMinutelyTodayOnProgress"
                :skin-mode="this.skinMode"
              />
              <b-card
                v-if="isMobile()"
              >
                <card-analytics-avg-page-statistics-daily
                  :data-object="pageViewsTotal"
                  :on-progress="pageViewsTotalOnProgress"
                />
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <page-view-table-daily
                :page-views="pageViews"
                :on-progress="pageViewsOnProgress"
                :details-page-url="detailsPageUrl"
                :by-content-filter="byContentFilter"
                @openDetails="openDetails"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-show="details"
          class="col-12 col-md-9"
        >
          <news-details
            :details="details"
            :on-progress="pageViewsOnProgress"
            @closeDetails="closeDetails"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
} from 'bootstrap-vue'

import querystring from 'querystring'
import usAppConfig from '@core/app-config/useAppConfig'
import ApexLineAreaChartDaily from '@/views/charts/apex/ApexLineAreaChartDaily.vue'
import PageViewTableDaily from '@/views/components/tables/PageViewTableDaily.vue'
import { executeQuery, resetQueries, resetQuery } from '@/coreApi/coreApiDataset'
import coreApiDataIndex from '@/coreApi/coreApiDataIndex'
import { getCoreApiData, getCoreApiDataOnProgress } from '@/coreApi/coreApi'
import PageFilter from '@/views/components/filters/PageFilter.vue'
import CardAnalyticTotalPageViewsDaily from '@/views/card/card-analytic/CardAnalyticTotalPageViewsDaily.vue'
import { coreApiPageDateRangeFilterObject } from '@/coreApi/filters/coreApiPageDateRangeFilter'
import { coreApiDetailFilterObject } from '@/coreApi/filters/coreApiDetailFilter'
import CardAnalyticsAvgPageStatisticsDaily from '@/views/card/card-analytic/CardAnalyticsAvgPageStatisticsDaily.vue'
import { getProjectCoreProjectId, getProjectFilterObject } from '@/coreApi/filters/coreApiFilterHelper'
import NewsDetails from '@/views/components/details/NewsDetails.vue'

// eslint-disable-next-line no-unused-vars,import/no-extraneous-dependencies
const moment = require('moment')

export default {
    components: {
        NewsDetails,
        CardAnalyticTotalPageViewsDaily,
        CardAnalyticsAvgPageStatisticsDaily,
        BCard,
        BRow,
        BCol,
        ApexLineAreaChartDaily,
        PageViewTableDaily,
        PageFilter,
    },
    data() {
        return {
            details: null,
            detailsPageUrl: null,
            seriesName7DaysAgo: '7 days ago',
            seriesName1DayAgo: 'Yesterday',
            seriesNameCurrentDay: 'Today',
            projectId: null,
            filter: null,
            shortCacheTime: 1200,
            longCacheTime: 2592000,
            byContentFilter: true,
            lastQueryHash: null,
            apexRender: 0,
        }
    },
    watch: {
        $route() {
            this.initQueries()
            this.intiDetails()
        },
    },
    created() {
        this.initQueries()
        this.intiDetails()
    },
    methods: {
        isMobile() {
            return window.innerWidth < 768
        },
        getCurrentHashList() {
            let currentHashList = {}
            if (this.$route.hash) {
                currentHashList = querystring.parse(this.$route.hash.slice(1))
            }
            return currentHashList
        },
        initQueries() {
            const projectFilterObject = getProjectFilterObject()
            const pageFilter = projectFilterObject.getFilterQueryObject()
            const pageDateRangeFilter = coreApiPageDateRangeFilterObject.getFilterQueryObject()
            const queryHash = JSON.stringify(pageFilter) + JSON.stringify(pageDateRangeFilter)
            if (!this.lastQueryHash || this.lastQueryHash !== queryHash) {
                this.lastQueryHash = queryHash
                this.runQuery(getProjectCoreProjectId(), pageFilter, pageDateRangeFilter)
            }
        },
        getFilterObject() {
            const projectFilterObject = getProjectFilterObject()
            return projectFilterObject.getFilterList()
        },
        runQuery(projectId, pageFilter, pageDateRangeFilter) {
            if (['bl8372p22-kd', 'bl8372p22-tv', 'bl8372p22-hs', 'bl8372p22-ms', 'bl8372p22-cns', 'bl8372p22-psts', 'bl8372p22-gvs', 'bl8372p22-rd', 'bl2ok5med65lk2-muo'].includes(projectId)) {
                this.byContentFilter = false
            } else {
                this.byContentFilter = true
            }
            let projectIdBase = projectId
            if (projectIdBase.indexOf('-') > -1) {
                projectIdBase = projectIdBase.slice(0, projectIdBase.indexOf('-'))
            }

            if (projectId === 'bl8372p22-hs') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl1767ftdlk224',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.hurriyet.com.tr',
                })
            } else if (projectId === 'bl8372p22-ms') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl2ok5med65lk2',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.milliyet.com.tr',
                })
            } else if (projectId === 'bl8372p22-cns') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl8372p22-cn',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.cnnturk.com',
                })
            } else if (projectId === 'bl8372p22-psts') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl8372p22-ps',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.posta.com.tr',
                })
            } else if (projectId === 'bl8372p22-gvs') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl8372p22-gv',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.gazetevatan.com',
                })
            } else if (projectId === 'bl1767ftdlk224-ho') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl1767ftdlk224',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'www.hurriyet.com.tr',
                })
            } else if (projectId === 'bl1767ftdlk224-hbo') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl1767ftdlk224',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'bigpara.hurriyet.com.tr,mbigpara.hurriyet.com.tr',
                })
            } else if (projectId === 'bl2ok5med65lk2-mo') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl2ok5med65lk2',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'www.milliyet.com.tr,m.milliyet.com.tr',
                })
            } else if (projectId === 'bl2ok5med65lk2-muo') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl2ok5med65lk2',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'uzmanpara.milliyet.com.tr,uzmanparam.milliyet.com.tr',
                })
            } else {
                pageFilter.push({
                    key: 'projectId',
                    value: projectId,
                })
            }

            const startDate = moment()
                .subtract(pageDateRangeFilter.skip, 'days')
            const startDatePreviews = moment()
                .subtract(pageDateRangeFilter.skip + 1, 'days')
            const startDatePreviews7 = moment()
                .subtract(pageDateRangeFilter.skip + 7, 'days')
            const startDateString = startDate.format('YYYY-MM-DD')
            const startDatePreviewString = startDatePreviews.format('YYYY-MM-DD')
            const startDatePreview7String = startDatePreviews7.format('YYYY-MM-DD')
            const endDate = startDate.add(pageDateRangeFilter.take - 1, 'days')
            const endDatePreviews = startDatePreviews.add(pageDateRangeFilter.take - 1, 'days')
            const endDatePreviews7 = startDatePreviews7.add(pageDateRangeFilter.take - 1, 'days')
            const endDateString = endDate.format('YYYY-MM-DD')
            const endDatePreviewString = endDatePreviews.format('YYYY-MM-DD')
            const endDatePreview7String = endDatePreviews7.format('YYYY-MM-DD')

            let timeout = this.longCacheTime
            if ((pageDateRangeFilter.skip === 0) || (pageDateRangeFilter.skip - pageDateRangeFilter.take === -1)) {
                timeout = this.shortCacheTime
            } else if (endDateString === moment()
                .subtract(1, 'days')
                .format('YYYY-MM-DD')) {
                // eslint-disable-next-line radix
                if (parseInt(moment()
                    .format('HH')) < 3) {
                    // Yesterday created at 00.32
                    timeout = 300
                }
            }
            // Diamond Page View Statistics Daily d0a5028aa1cd4
            // Diamond Page View Daily tdf43ebdbbf2d
            // Diamond Daily Graph Minutely Page View Count b4c2116a791ad
            executeQuery(
                coreApiDataIndex.d1,
                {
                    startDate: startDateString,
                    endDate: endDateString,
                    timeout,
                    request_nodes: [
                        {
                            project_id: projectIdBase,
                            alias: 'dailyPageViewStatistics',
                            options: [
                                {
                                    alias: 'dailyPageViewStatistics',
                                    return_id: 'statistics',
                                    offset: 0,
                                    limit: 1,
                                },
                                {
                                    alias: 'pageView',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulativePageView',
                                    filter_date_indicator: pageDateRangeFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'dailyPageViewDetails',
                            options: [
                                {
                                    alias: 'dailyPageViewDetails',
                                    return_id: 'pageView',
                                    offset: 0,
                                    limit: 200,
                                },
                                {
                                    alias: 'pageView',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulativePageView',
                                    filter_date_indicator: pageDateRangeFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'dailyPageViewGraphPVCount',
                            options: [
                                {
                                    alias: 'dailyPageViewGraphPVCount',
                                    return_id: 'graph',
                                    filter_values: pageFilter,
                                    offset: 0,
                                    limit: 3000,
                                },
                                {
                                    alias: 'pageView',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulativePageView',
                                    filter_date_indicator: pageDateRangeFilter,
                                },
                            ],
                        },
                    ],
                },
            )

            if (pageDateRangeFilter.take === 1) {
                let selectedData = moment()
                    .subtract(pageDateRangeFilter.skip, 'days')
                this.seriesNameCurrentDay = selectedData.format('MMM Do dddd')
                this.seriesName1DayAgo = selectedData.subtract(1, 'days')
                    .format('MMM Do dddd')
                this.seriesName7DaysAgo = selectedData.subtract(6, 'days')
                    .format('MMM Do dddd')

                const oneDayBefore = { ...pageDateRangeFilter }
                oneDayBefore.skip += 1

                let yesterdayTimeout = this.longCacheTime
                // eslint-disable-next-line radix
                if (parseInt(moment()
                    .format('HH')) < 1) {
                    // Yesterday created at 00.32
                    yesterdayTimeout = this.shortCacheTime
                }

                //  Diamond Daily Graph Minutely Page View Count  b4c2116a791ad
                executeQuery(
                    coreApiDataIndex.d3,
                    {
                        startDate: startDatePreviewString,
                        endDate: endDatePreviewString,
                        timeout: yesterdayTimeout,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'dailyPageViewGraphPVCount',
                                options: [
                                    {
                                        alias: 'dailyPageViewGraphPVCount',
                                        return_id: 'yesterday',
                                    },
                                    {
                                        alias: 'pageView',
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'cumulativePageView',
                                        filter_date_indicator: oneDayBefore,
                                    },
                                ],
                            },
                        ],
                        version: 1,
                    },
                )

                const sevenDaysBefore = { ...pageDateRangeFilter }
                sevenDaysBefore.skip += 7
                if (pageDateRangeFilter.skip > 0) {
                    this.seriesName7DaysAgo = moment()
                        .subtract(sevenDaysBefore.skip, 'd')
                        .format('MMM Do dddd')
                }

                // Diamond Daily Graph Minutely Page View Count b4c2116a791ad
                executeQuery(
                    coreApiDataIndex.d4,
                    {
                        startDate: startDatePreview7String,
                        endDate: endDatePreview7String,
                        timeout: this.longCacheTime,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'dailyPageViewGraphPVCount',
                                options: [
                                    {
                                        alias: 'dailyPageViewGraphPVCount',
                                        return_id: 'sevenDaysAgo',
                                    },
                                    {
                                        alias: 'pageView',
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'cumulativePageView',
                                        filter_date_indicator: sevenDaysBefore,
                                    },
                                ],
                            },
                        ],
                        version: 1,
                    },
                )

                // Check if the User Statistics Data is available
                // for applied filters and call or cancel the query accordingly
                // Validation Starts
                let userStatisticsValid = true

                const validUserFilters = [
                    'projectId',
                    'origin_referer_domain',
                    'source',
                    'device',
                    'user_types',
                ]

                pageFilter.forEach(pageFilterItem => {
                    if (!validUserFilters.includes(pageFilterItem.key)) {
                        userStatisticsValid = false
                    }
                })

                if (userStatisticsValid) {
                    // Diamond User Statistics Daily Today
                    executeQuery(
                        coreApiDataIndex.d6,
                        {
                            startDate: startDateString,
                            endDate: endDateString,
                            timeout,
                            request_nodes: [
                                {
                                    project_id: projectIdBase,
                                    alias: 'userStatisticsDaily',
                                    options: [
                                        {
                                            alias: 'userStatisticsDaily',
                                            return_id: 'd6',
                                            offset: 0,
                                            limit: 1,
                                            filter_values: pageFilter,
                                        },
                                        {
                                            alias: 'userDaily',
                                            filter_date_indicator: pageDateRangeFilter,
                                        },
                                    ],
                                },
                            ],
                        },
                    )

                    // User Statistics 7 Days Ago
                    executeQuery(
                        coreApiDataIndex.d7,
                        {
                            startDate: startDatePreview7String,
                            endDate: endDatePreview7String,
                            timeout: this.longCacheTime,
                            request_nodes: [
                                {
                                    project_id: projectIdBase,
                                    alias: 'userStatisticsDaily',
                                    options: [
                                        {
                                            alias: 'userStatisticsDaily',
                                            return_id: 'userStatisticsSevenDaysAgo',
                                            offset: 0,
                                            limit: 1,
                                            filter_values: pageFilter,
                                        },
                                        {
                                            alias: 'userDaily',
                                            filter_date_indicator: sevenDaysBefore,
                                        },
                                    ],
                                },
                            ],
                        },
                    )
                } else {
                    selectedData = moment()
                        .subtract(pageDateRangeFilter.skip, 'days')
                    this.seriesName7DaysAgo = '-'
                    this.seriesName1DayAgo = '-'
                    this.seriesNameCurrentDay = `${selectedData.format('MMM Do dddd')} - ${endDate.format('MMM Do dddd')}`
                    resetQuery(coreApiDataIndex.d3)
                    resetQuery(coreApiDataIndex.d4)
                    resetQuery(coreApiDataIndex.d6)
                    resetQuery(coreApiDataIndex.d7)
                }
            } else {
                resetQuery(coreApiDataIndex.d6)
                resetQuery(coreApiDataIndex.d7)
            }
            // Validation Ends
        },
        intiDetails() {
            const projectFilterObject = getProjectFilterObject()
            const detailsObject = projectFilterObject.getFilterDetails()
            if (detailsObject) {
                if (
                    !this.details
                    && detailsObject.pageUrl
                ) {
                    this.detailsPageUrl = detailsObject.pageUrl
                }
            } else {
                this.closeDetails()
            }
        },
        openDetails(obj) {
            if (obj.details && obj.details.pageUrl) {
                const filters = { details: { pageUrl: obj.details.pageUrl } }
                const newPath = coreApiDetailFilterObject.getFilterUrl(filters)
                if (newPath !== this.$route.fullPath) {
                    this.$router.push(newPath)
                }
                this.detailsPageUrl = obj.details.pageUrl
            } else {
                this.closeDetails()
            }
            this.details = obj.details
        },
        closeDetails() {
            const filters = { details: null }
            const newPath = coreApiDetailFilterObject.getFilterUrl(filters)
            if (newPath !== this.$route.fullPath) {
                this.$router.push(newPath)
            }
            this.detailsPageUrl = null
            this.details = null
            this.apexRender += 1
        },
    },
    setup() {
        return {
            pageViewsTotal: getCoreApiData(coreApiDataIndex.d1),
            pageViewsTotalOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d1),
            graphMinutelyToday: getCoreApiData(coreApiDataIndex.d1),
            graphMinutelyTodayOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d1),
            graphMinutelyYesterday: getCoreApiData(coreApiDataIndex.d3),
            graphMinutelyYesterdayOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d3),
            graphMinutely7DayAgo: getCoreApiData(coreApiDataIndex.d4),
            graphMinutely7DayAgoOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d4),
            pageViews: getCoreApiData(coreApiDataIndex.d1),
            pageViewsOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d1),
            userStatistics: getCoreApiData(coreApiDataIndex.d6),
            userStatisticsOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d6),
            userStatisticsSevenDaysAgo: getCoreApiData(coreApiDataIndex.d7),
            userStatisticsSevenDaysAgoOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d7),
            skinMode: usAppConfig().skin,
        }
    },
    beforeRouteLeave(to, from, next) {
        resetQueries()
        next()
    },
}
</script>

<style>

</style>
